import axios from "axios";
import { PersonaleContabileService } from "./service";
import { keycloak } from "../../../../lib/keycloak";
import { GetAllPersonaleContabileFiltersDTO, GetAllPersonaleContabileResponseData } from "./dto";
import { ProformaStatus } from "../../../../utils";
import { filter } from "jszip";

export class PersonaleContabileImpl implements PersonaleContabileService {

    public GetAllPersonaleContabile(filters: GetAllPersonaleContabileFiltersDTO): Promise<GetAllPersonaleContabileResponseData[]> {
        return axios.get("/api/monitoring/personal-accounting", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                year: filters.year ? filters.year : null,
                inspectorCode: filters.inspectorCode ? filters.inspectorCode : null,
                status: filters.status ? filters.status : null,
                invoice: filters.invoice ? filters.invoice : null,
                proformaStatus: filters.proformaStatus ? filters.proformaStatus : null
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}